//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            current:0,
            menuName:[
                        {name:"应用",show:false},
                        {name:"源码",show:false},
                        {name:"硬件",show:false},
                     ],
            Submenu:[
                        {name:"全部",id:"1"},
                        {name:"采集设备",id:"2"},
                        {name:"无线扫描枪",id:"3"}
                     ],
            num:'',
            isShow:0,
            showIndex:0,
            saasappType:"",
            saasDbType:"",
            paasappType:"",
            paasDbType:"",
            arrangeType:"",
            hardwareAppType:"",
            typeList:[],
            sqlList:[],
            typeNum:0,
            typeNum1:0,
            sqlNum:"",
            arrangeNum:"",
            sqlNum1:"",
            typeNum2:0,
            OneList:[],
            TwoList:[],
            ThreeList:[],
            goodsTypeId:0,
            BuList:[
                    { name:"全部"},
                    { name:"线上部署"},
                    { name:"线下部署"}
                    ],
            model:{goodsType1:-1,goodsType2:-1,goodsType3:-1}
        }
    },
     created(){
        this.getTypeList();
        this.getsqlList();
        this.getHWList(0);
    },
    methods: {
        goBack(){
            app.goBack();
        },
        gotoGood(index){
            this.num=index;
            this.isShow = index;
            this.showIndex=index;
      },
      cancel(){
            // console.log(this.model);
            this.typeNum="";
            this.typeNum1="";
            this.sqlNum="";
            this.arrangeNum="";
            this.sqlNum1="";
            this.typeNum2="";
            this.goodsTypeId=0;
            this.model.goodsType1=-1;
            this.model.goodsType2=-1;
            this.model.goodsType3=-1;
            this.ThreeList=[];
            this.TwoList=[];

      },
      doSearch(){
          if(this.showIndex==0){
            this.$router.push({path:'/ntalk/mall/app/list',query:{'dbType':this.saasDbType,'arrangeType':this.arrangeType,'appType':this.saasappType,'typeIndex':this.typeNum}});
          }else if(this.showIndex==1){
            this.$router.push({
                path:'/ntalk/mall/paas/list',
                query:{
                    'dbType':this.paasDbType,
                    'appType':this.paasappType,
                    'typeIndex':this.typeNum1
                    }
                });
          }else if(this.showIndex==2){
            this.$router.push({
                path:'/ntalk/mall/hardware/list',
                query:{
                    'appType':this.hardwareAppType,
                    'goodsType1':this.model.goodsType1,
                    'goodsType2':this.model.goodsType2,
                    'goodsType3':this.model.goodsType3,
                    'typeIndex':this.typeNum2
                    }
                });
          }
      },
      getTypeList(){
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mdemand/getAppTypes',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                 this.typeList = res.body.data;

                    }
                },function(res){
            });
        },
        getsqlList(){
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpass/getDbTypes',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                 this.sqlList = res.body.dbTypes;

                    }
                },function(res){
            });
        },
        getSaasTypeId(item,index){
            this.typeNum=index;
            // this.saasappType= index;
            if(item.appTypeId !=undefined){
            this.saasappType= item.appTypeId;
            }else{
                this.saasappType=null;
            }
        },
        getPaasTypeId(item,index){
            this.typeNum1=index;
            // this.paasappType= index;
            if(item.appTypeId !=undefined){
            this.paasappType= item.appTypeId;
            }else{
                this.paasappType=null;
            }
        },
        getHardwareTypeId(item,index){
            this.typeNum2=index;
            // this.hardwareAppType= index;
            if(item.appTypeId !=undefined){
            this.hardwareAppType= item.appTypeId;
            }else{
                this.hardwareAppType=null;
            }
        },
        getSaasSqlId(item,index){
            this.sqlNum=index;
            if(item.dbType !=undefined){
            this.saasDbType= item.dbType;
            }else{
                this.saasDbType=null;
            }
        },
        getPaasSqlId(item,index){
            this.sqlNum1=index;
            if(item.dbType !=undefined){
            this.paasDbType= item.dbType;
            }else{
                this.paasDbType=null;
            }
        },
        getArrangeType(i){
           this.arrangeNum=i;
           this.arrangeType=i;
        },
        getHWList(goodsTypeId){
            this.model.goodsTypeId=goodsTypeId;
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mapp/getGoodsTypeList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                        this.OneList = res.body.rows;
                    }
                },function(res){
            });
        },
        getSubtype(){
            this.model.goodsTypeId=this.model.goodsType1;
            this.TwoList=[];
            this.ThreeList=[];
            this.model.goodsType2=-1;
            this.model.goodsType3=-1;
            var self=this;

            this.$http.post(this.global.httpUrl + '/rest/v1/m/mapp/getSubType',this.model,{emulateJSON:true}).then(function(res){
                if(res.body.success)
                {
                    self.TwoList = res.body.rows;
                }
            },function(res){
            });
        },
        getSubtype1(){
            this.model.goodsTypeId=this.model.goodsType2;
                this.ThreeList=[];
                this.model.goodsType3=-1;
                var self=this;
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mapp/getSubType',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                        self.ThreeList = res.body.rows;
                    }
                },function(res){
            });
        }
    },


}



// WEBPACK FOOTER //
// ./src/views/ntalk/goods/search.vue